import { render } from "./EditProduitRestreint.vue?vue&type=template&id=503c38ec&ts=true"
import script from "./EditProduitRestreint.vue?vue&type=script&lang=ts"
export * from "./EditProduitRestreint.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__